export function QEncodeChar(c) {
  var s;
  switch (c) {
    case "<":
      s = "&lt;";
      break;
    case ">":
      s = "&gt;";
      break;
    case "&":
      s = "&amp;";
      break;
    case "'":
      s = "&apos;";
      break;
    case '"':
      s = "&quot;";
      break;
    case "\n":
      s = "&#xD;";
      break;
    case "​":
      // FindCharBreak appends this zero-width space (U+200B) as an internal
      // row-break sentinel on explicit newlines. It must not survive into
      // exported SVG/XML because cairosvg (PNG/JPG export) renders it as a
      // missing-glyph box.
      s = "";
      break;
    default:
      s = c;
      break;
  }

  return s;
}
